import * as React from 'react';
import { Schedule } from '../schedule/schedule';
import { EventScheduleController } from './event-schedule-controller';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/take';

interface EventScheduleState {
};

export class EventSchedule extends React.Component<{}, EventScheduleState> {

  state = {
  };

  controller = new EventScheduleController();

  render() {

    return (
      <div>
        <Schedule controller={this.controller}></Schedule>
      </div>
    );

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/event-schedule/event-schedule.tsx